import {Component, Input} from '@angular/core';
import {AdxInvoiceService} from '../../service/adx-invoice.service';
import {AdxInvoiceDetailResponse} from '../../model/adx-invoice-detail-response';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {DatePipe} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {AdxErpPayloadDialogComponent} from '../../../dashboard-finance/adx-erp-panel/components/adx-erp-payload-dialog/adx-erp-payload-dialog.component';

@Component({
    selector: 'app-adx-invoice-info',
    templateUrl: './adx-invoice-info.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class AdxInvoiceInfoComponent {
  @Input() public data: any;
  _adxInvoice!: any;
  payload: string | null = null;

  constructor(
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private adxInvoiceService: AdxInvoiceService) {
  }

  ngOnInit(){
    this.getAdxInvoiceInfo();
  }

  getAdxInvoiceInfo() {
    if (this.data != null){
      this.adxInvoiceService
        .searchByQueryAdxInvoices({ id: this.data.adxInvoiceId })
        .subscribe((data: AdxInvoiceDetailResponse[]) => {
          if (data.length > 0){
            this._adxInvoice = data[0];
            this.getInvoicePayload(this._adxInvoice.id);
          }
        });
    }
  }

  getInvoicePayload(adxInvoiceId: number): void {
    this.adxInvoiceService
      .getInvoicePayload(adxInvoiceId)
      .subscribe((payload) => {
        this.payload = payload;
      });
  }

  viewPayload(): void {
    if (!this.payload) return;
    this.dialog.open(AdxErpPayloadDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      data: {title: 'Invoice Payload', content: this.payload},
    });
  }

  formatDate(date: string): string {
    return this.datePipe.transform(date, 'MM/dd/yyyy') || '';
  }
}
